import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const DriverVisionStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_vision).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title="Har du dokumentation for synstest?">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <fieldset>
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              name="dlHasVisionDoc"
              checked={!!selfServiceData.dlHasVisionDoc}
              onChange={(e) => updateSelfServiceData('dlHasVisionDoc', e.target.checked)}
            />
            <span>Ja, jeg medbringer dokumentation for synstest</span>
          </label>
        </div>
      </fieldset>
      <NavigationButtons onBack={goBack} onNext={goNext} nextDisabled={!selfServiceData.dlHasVisionDoc} />
    </StepContainer>
  );
};

export default DriverVisionStep;


